<template>
<div>
  <v-flex
      class="blog-feed-container"
      >

      <router-link v-for="(blog, index) in feeds" :key="index" :to="`/blog/${blog.language}/${blog.id}`">
      <div class="blog-container">
        <h2>{{blog.title}}</h2>
        <p>{{blog.desc}}</p>

        <div class="blog-desc">{{$lang.blog.written_by}}: <span style="color:#3CCEBD">{{blog.author}}</span>  |  {{getDate(blog.date)}}  |  {{blog.duration}} </div>
      </div>
        
  </router-link>
      </v-flex>
    </div>
</template>

<script>
export default {
  name: "BlogSection",
  props: ['feeds'],
  data() {
    return {
      style: "",
      blogs:[{},{},{},{},{},{},{},{}]
    };
  },
  methods: {
    onClick(blog) {
      const me = this;
      if(blog && blog.id){
        me.$router.push({ path: `/blog/${blog.language}/${blog.id}` })
      //  me.$emit('nav-to-blog',blog);
      }
    },
    getDate(date){
        const me = this;
        let tempDate = new Date(date * 1000)
        let month = tempDate.toLocaleString('default', { month: 'long' });
        
        return me.$lang.common[month.toLowerCase()]+' '+tempDate.getDate()+me.$lang.common['th']
    }
  }
};
</script>

<style scoped>

.blog-feed-container{
   padding: 0px 100px 40px 100px;
    height:100%;
}

.blog-container{
    width:100%;    
    -webkit-box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
    box-shadow: 0 1px 4px rgb(1 1 1 / 15%);
    border-radius: 5px;
    display:block;
    margin:20px 0px;
    padding:30px;
    cursor: pointer;
  transition: all 0.25s ease-out;
    border: 1px solid transparent;
}

.blog-container:hover {
    /* -webkit-box-shadow: 0 1px 2px rgb(24 231 211 / 100%);
    box-shadow: 0 1px 2px rgb(24 231 211 / 100%); */
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid #18e7d3;
}

.blog-container h2{
    letter-spacing: 1px;
    text-transform: none;
    color: black;
    font-weight: 400;
}
.blog-container p{
    font-size:18px;
    margin:0 auto;
    font-weight: 200;
    max-width:60%;
    margin-bottom:40px;
}
.blog-container .blog-desc{
    color: #252525;
    font-weight: 300;
    font-size: 14px;
}
@media only screen and (max-device-width: 600px) {


.blog-feed-container {
    padding: 0px;
}
.blog-container{
  padding-left:20px;
  padding-right:20px;
  padding-bottom:50px;
}

.blog-container p{
    font-size:16px;
    margin:0 auto;
    font-weight: 200;
    max-width:100%;
    margin-bottom:40px;
}

}
</style>
